(function () {
    angular.module('tmx-app')
        .filter('trusted', ['$sce', function ($sce) {
            return function (html) {
                return $sce.trustAsHtml(html)
            }
        }]);
})();